import { useContext, useEffect } from 'react';
import { message } from 'antd';
import useHttpClient from 'shared/hooks/http-hook';
import { AuthContext } from 'shared/context/auth-context';
import  EndPoints from 'shared/endPoints/EndPoints.json';
import LoginForm from './LoginForm';

function LoginSubmission() {
  const { login } = useContext(AuthContext);
  const { status, responseData, sendRequest, responseMessage } =
    useHttpClient();
  const onSubmit = data => {
    sendRequest(
      {
        endpoint:EndPoints.USER.LOGIN,
        method: 'POST',
        data
      },
      'LOGIN',
      'Η είσοδος ήταν επιτυχής'
    );
  };

  useEffect(() => {
    if (status === 'pending') {
      message.loading();
    }

    if (status === 'resolved') {
      login(responseData?.accessToken);
      message.success(responseMessage);
    }
  }, [status, responseData, login, responseMessage]);
  return <LoginForm onSubmit={onSubmit} />;
}

export default LoginSubmission;
